import styled, { keyframes } from 'styled-components'
import { drawStroke, rotate180 } from '../animate'

export const LumberStyled = styled.svg`
  .stroke {
    stroke: ${props => props.theme};
  }

  &.is-animated {
    &:hover {
      .path-1 {
        animation: ${rotate180} 1s linear forwards;
      }
      .path-2 {
        stroke-dasharray: 100;
        stroke-dashoffset: 100;
        animation: ${drawStroke} 1s linear forwards;
      }
    }
  }
`
